import { useBunja } from 'bunja/react';

import { useRouter } from '@flipster/i18n/routing';
import { Button } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system/modal';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { entryPopupBlockBunja, entryPopupItemBunja } from '../../bunja';

export const CopyTradingOnboardingModal = () => {
  const router = useRouter();
  const { popup, onClose } = useBunja(entryPopupItemBunja);
  const { block } = useBunja(entryPopupBlockBunja);

  if (popup.id !== 'COPY_TRADING_IS_NOW_LIVE') throw new Error('Popup ID mismatch');

  return (
    <Modal.Root onClose={onClose} mode='bottomSheet'>
      <Modal.Header>
        <Modal.Title label='Copy trading is now live' />
      </Modal.Header>
      <Modal.Content>
        <div className={stack({ gap: 24 })}>
          <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
            Copy verified traders and earn up to 10% APR while you trade.
          </p>
          <div className={css({ w: '100%', h: 200, rounded: 12, bg: 'background.default.level-1' })}>TODO: image</div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          label='Start copy trading'
          css={{ w: '100%' }}
          onClick={() => {
            router.push('/copy-trading');
            block('COPY_TRADING_IS_NOW_LIVE');
            onClose();
          }}
        />
      </Modal.Footer>
    </Modal.Root>
  );
};
